import React, { useEffect, useState } from "react";
// MUI
import { Box, useMediaQuery } from "@mui/material";
import { Grid, Stack, useTheme, Divider } from "@mui/material";
//css
import "./HomePageContentDesktop.css";
import freeShipping from "../../../svg/fi-free-delivery-48.svg";
import hour24 from "../../../svg/fi-24-hours-48.svg";
import paymentSecurity from "../../../svg/fi-payment-security-48.svg";
import hotOffer from "../../../svg/fi-tag-48.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  GetManufacturerList,
  GetProductDetails,
  GetProductWithCode,
  getFilterDataX,
  getProductsCount,
  getVehicleId,
  selectedMfgCleanUp,
  setdataCleanUp,
  setselectedMfg,
  setvehicleFinderObj,
  setvehicleFinderObjCleanUp,
} from "../../../Redux/Reducers/reducerSlices/ProductsSlices/ProductDetailsSlice";
import { CenteredGrid, ColorButtonYellow } from "../../../Themes/Theme";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../Shared/Breadcrumb";
import WaveHeader from "../../Shared/WaveHeader/WaveHeader";
export default function HomePageContentDesktop() {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMediumScreen = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const direction = isMediumScreen ? "column" : "row";
  const items = Array.from({ length: 16 });
  const dispatch = useDispatch();
  const {
    Mdata,
    countObj,
    model,
    year,
    series,
    cc,
    fuelType,
    bodyType,
    manufacturer,
    yearFrom,
    vehicleIDs,
    isLoading,
  } = useSelector((state) => state.ProductDetails);
  const productsData = useSelector((state) => state.ProductDetails?.data) || [];
  const cartProducts = useSelector((state) => state.addToCart.cartProducts);

  const state = useSelector((state) => state.ProductDetails);
  const userData = useSelector((state) => state.login.data[0]);
  const [suggestions, setSuggestions] = useState([]);
  const [show, setShow] = useState(false);

  // console.log(vehicleIDs, "vehicle IDs all");
  // console.log(state, model, manufacturer, year, series, cc, fuelType, bodyType);
  const [selectOptions, setSelectOptions] = useState({
    manufacturer: null,
    model: null,
    year: null,
    series: null,
    cc: null,
    fuelType: null,
    bodyType: null,
  });
  const [searchTerm, setSearchTerm] = useState({
    s1: "",
    s2: "",
    s3: "",
    s4: "",
  });
  const [fs, setFs] = useState("");
  const [manufacturerData, setManufacturerData] = useState();
  useEffect(() => {
    dispatch(GetManufacturerList());
  }, []);
  useEffect(() => {
    setManufacturerData(Mdata);
  }, [Mdata, cartProducts]);
  const handleSection = (value, type, id = 1) => {
    // console.log(value, type);
    const obj = selectOptions;
    obj[type] = value;
    setSelectOptions((prevstate) => ({ ...prevstate, ...obj }));
    if (value) {
      // console.log("yyyyyyyyyyyyyyyyy");
      if (selectOptions.manufacturer)
        dispatch(setselectedMfg(selectOptions.manufacturer));
      dispatch(
        getProductsCount({
          manufacturer: null,
          model: null,
          year: null,
          series: null,
          cc: null,
          fuelType: null,
          bodyType: null,
          ...obj,
        })
      );
      dispatch(
        getVehicleId({
          manufacturer: null,
          model: null,
          year: null,
          series: null,
          cc: null,
          fuelType: null,
          bodyType: null,
          ...obj,
        })
      );
      // console.log("iiiiiiiiiiiiiiiiiiiiiiiiiii", obj);
      id &&
        dispatch(
          getFilterDataX({
            action: {
              manufacturer: null,
              model: null,
              series: null,
              cc: null,
              fuelType: null,
              type: id,
              ...obj,
              yearFrom: type === "year" ? value : selectOptions.year || null,
            },
            type: type == "year" ? "yearFrom" : type,
          })
        );

      dispatch(setvehicleFinderObj(obj));
    }
  };

  const globalSearch = () => {
    dispatch(setdataCleanUp());
    dispatch(
      GetProductDetails({
        SearchInput: vehicleIDs?.vehicleID,
        type: 1,
        userID: userData?.id || null,
      })
    );
    if (!isLoading) {
      navigate("/ProductView");
    }
  };
  console.log(Mdata);

  const filteredProducts = productsData
    ? Mdata?.filter(
        (product) =>
          product?.partManufacturer?.toLowerCase().includes(fs.toLowerCase()) ||
          product?.productcode?.toLowerCase().includes(fs.toLowerCase()) ||
          product.manufacturer?.toLowerCase().includes(fs.toLowerCase())
      )
    : manufacturerData;
  const handleSearchTerm = (e) => {
    const { name, value } = e.target;
    if (name === "s4") {
      setShow(true);
      setFs(value);
    }
    setSearchTerm((prev) => ({
      ...prev,
      [name]: value,
    }));
    console.log(name, value);
  };
  const searchBtn = (type) => {
    console.log(type);
    dispatch(setdataCleanUp());
    dispatch(selectedMfgCleanUp());
    dispatch(setvehicleFinderObjCleanUp());
    setShow(false);
    if (type === "s1") {
      dispatch(
        GetProductDetails({
          SearchInput: searchTerm?.s1,
          type: 5,
          userID: userData?.id || null,
        })
      );
    } else if (type === "s2") {
      dispatch(
        GetProductDetails({
          SearchInput: searchTerm?.s2,
          type: 2,
          userID: userData?.id || null,
        })
      );
    } else if (type === "s3") {
      // console.log(searchTerm);
      dispatch(
        GetProductWithCode({
          SearchInput: searchTerm?.s3,
          userID: userData?.id || null,
        })
      );
    } else if (type === "s4") {
      dispatch(
        setselectedMfg(
          suggestions?.manufacturer || searchTerm?.s4?.toUpperCase()
        )
      );
      dispatch(
        GetProductDetails({
          SearchInput:
            suggestions?.manufacturer || searchTerm?.s4?.toUpperCase(),
          type: 4,
          userID: userData?.id || null,
        })
      );
    }
    if (!isLoading) {
      navigate("/ProductView");
    }
  };
  const handleSuggestionClick = (value) => {
    console.log(value);

    setShow(false);
    setSuggestions(value);
    setSearchTerm((prev) => ({ ...prev, s4: value?.manufacturer }));

    // console.log(value);
  };
  return (
    <Box
      sx={{
        background: "#fafafa",
        padding: {
          xl: "12px 5em ",
          lg: "12px 5em ",
          sm: "12px 3em ",
          xs: "12px 1em ",
        },
        zIndex: "-1",
      }}
    >
      <Stack direction={"row"} mb={1.1}>
        <Breadcrumb text={"Home"} />
      </Stack>
      <div className="catalogue-container">
        <div className="catalogue">
          <WaveHeader title={"Catalogue"} type={"catalogue"} />
          <div className="catalogue-search">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "row",
                marginBottom: "20px",
              }}
            >
              <input
                disabled={isLoading}
                style={{
                  marginLeft: "20px",
                  marginRight: "20px",
                  minWidth: "250px",
                }}
                className="NBM-Search-Box" //NBM refers to Nav bar mid
                placeholder={"Our part Number"}
                value={searchTerm?.s1}
                name="s1"
                onChange={(e) => {
                  handleSearchTerm(e);
                }}
              />
              <ColorButtonYellow
                onClick={() => searchBtn("s1")}
                className="NBM-ColorButtonText"
                startIcon={<DirectionsCarIcon />}
                disabled={isLoading}
              >
                {isLoading ? "Loading...." : "Search"}
              </ColorButtonYellow>
            </div>
          </div>
          <div className="catalogue-search">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "row",
                marginBottom: "20px",
              }}
            >
              <input
                disabled={isLoading}
                style={{
                  marginLeft: "20px",
                  marginRight: "20px",
                  minWidth: "250px",
                }}
                className="NBM-Search-Box" //NBM refers to Nav bar mid
                placeholder={"Engine code"}
                value={searchTerm?.s2}
                name="s2"
                onChange={(e) => {
                  handleSearchTerm(e);
                }}
              />
              <ColorButtonYellow
                onClick={() => searchBtn("s2")}
                className="NBM-ColorButtonText"
                startIcon={<DirectionsCarIcon />}
                disabled={isLoading}
              >
                {isLoading ? "Loading...." : "Search"}
              </ColorButtonYellow>
            </div>
          </div>
          <div className="catalogue-search">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "row",
                marginBottom: "20px",
              }}
            >
              <input
                disabled={isLoading}
                style={{
                  marginLeft: "20px",
                  marginRight: "20px",
                  minWidth: "250px",
                }}
                className="NBM-Search-Box" //NBM refers to Nav bar mid
                placeholder={"Manufacturers Part Code"}
                value={searchTerm?.s3}
                name="s3"
                onChange={(e) => {
                  handleSearchTerm(e);
                }}
              />
              <ColorButtonYellow
                onClick={() => searchBtn("s3")}
                className="NBM-ColorButtonText"
                startIcon={<DirectionsCarIcon />}
                disabled={isLoading}
              >
                {isLoading ? "Loading...." : "Search"}
              </ColorButtonYellow>
            </div>
          </div>
          <div className="catalogue-search">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "row",
                marginBottom: "20px",
              }}
            >
              <input
                disabled={isLoading}
                style={{
                  marginLeft: "20px",
                  marginRight: "20px",
                  minWidth: "250px",
                }}
                className="NBM-Search-Box" //NBM refers to Nav bar mid
                placeholder={"Manufacturer"}
                value={searchTerm?.s4}
                name="s4"
                onChange={(e) => {
                  handleSearchTerm(e);
                }}
              />
              <ColorButtonYellow
                onClick={() => searchBtn("s4")}
                className="NBM-ColorButtonText"
                startIcon={<DirectionsCarIcon />}
                disabled={isLoading}
              >
                {isLoading ? "Loading...." : "Search"}
              </ColorButtonYellow>
              {show && fs && (
                <ul className="autosuggest-list">
                  {filteredProducts?.map((suggestion, index) => (
                    <li
                      className="suggestion-item"
                      key={index}
                      onClick={(e) => handleSuggestionClick(suggestion)}
                      style={{ cursor: "pointer", padding: "5px" }}
                    >
                      {suggestion?.manufacturer}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
        <div className="wave-and-finder-wrapper">
          <WaveHeader title={"Vehicle Finder"} type={"vehicleFinder"} />
          <div id="vehicle-finder" className="section-container">
            <div className="dd-containser">
              <Grid container spacing={2} display={"flex"}>
                <CenteredGrid
                  item
                  xs={3}
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <select
                    className="select-sectio"
                    onChange={(e) =>
                      handleSection(e.target.value, "manufacturer", 1)
                    }
                  >
                    <option value={null} title="">
                      Manufacturer
                    </option>
                    {Mdata && Mdata?.length ? (
                      <>
                        {Mdata.map((e, i) => (
                          <option
                            key={i}
                            title={e?.manufacturer}
                            value={e?.manufacturer}
                          >
                            {e.manufacturer}
                          </option>
                        ))}
                      </>
                    ) : (
                      ""
                    )}
                  </select>
                </CenteredGrid>
                {selectOptions.manufacturer ? (
                  <CenteredGrid item xs={3}>
                    <select
                      className="select-sectio"
                      onChange={(e) =>
                        handleSection(e.target.value, "model", 2)
                      }
                    >
                      <option value={null}>Model</option>
                      {manufacturer && manufacturer?.length ? (
                        <>
                          {manufacturer.map((e, i) => (
                            <option key={i} title={e?.value} value={e?.value}>
                              {e.value}
                            </option>
                          ))}
                        </>
                      ) : (
                        ""
                      )}{" "}
                    </select>
                  </CenteredGrid>
                ) : (
                  ""
                )}
                {selectOptions.manufacturer && selectOptions.model ? (
                  <CenteredGrid item xs={3}>
                    <select
                      className="select-sectio"
                      onChange={(e) => handleSection(e.target.value, "year", 3)}
                    >
                      <option value={null}>Year</option>
                      {model && model?.length ? (
                        <>
                          {model.map((e, i) => (
                            <option key={i} title={e?.value} value={e?.value}>
                              {e.value}
                            </option>
                          ))}
                        </>
                      ) : (
                        ""
                      )}
                    </select>
                  </CenteredGrid>
                ) : (
                  ""
                )}

                {selectOptions.manufacturer &&
                selectOptions.model &&
                selectOptions.year ? (
                  <CenteredGrid item xs={3}>
                    <select
                      className="select-sectio"
                      onChange={(e) =>
                        handleSection(e.target.value, "series", 4)
                      }
                    >
                      <option value={null}>series</option>
                      {yearFrom && yearFrom?.length ? (
                        <>
                          {yearFrom.map((e, i) => (
                            <option key={i} title={e?.value} value={e?.value}>
                              {e.value}
                            </option>
                          ))}
                        </>
                      ) : (
                        ""
                      )}
                    </select>
                  </CenteredGrid>
                ) : (
                  ""
                )}
                {selectOptions.manufacturer &&
                selectOptions.model &&
                selectOptions.year &&
                selectOptions.series ? (
                  <CenteredGrid item xs={3}>
                    <select
                      className="select-sectio"
                      onChange={(e) => handleSection(e.target.value, "cc", 5)}
                    >
                      <option value={null}>Capacity</option>
                      {series && series?.length ? (
                        <>
                          {series.map((e, i) => (
                            <option key={i} title={e?.value} value={e?.value}>
                              {e.value}
                            </option>
                          ))}
                        </>
                      ) : (
                        ""
                      )}{" "}
                    </select>
                  </CenteredGrid>
                ) : (
                  ""
                )}
                {selectOptions.manufacturer &&
                selectOptions.model &&
                selectOptions.year &&
                selectOptions.series &&
                selectOptions.cc ? (
                  <CenteredGrid item xs={3}>
                    <select
                      className="select-sectio"
                      onChange={(e) =>
                        handleSection(e.target.value, "fuelType", 6)
                      }
                    >
                      <option value={null}>Fuel Type</option>
                      {cc && cc?.length ? (
                        <>
                          {cc.map((e, i) => (
                            <option key={i} title={e?.value} value={e?.value}>
                              {e.value}
                            </option>
                          ))}
                        </>
                      ) : (
                        ""
                      )}{" "}
                    </select>
                  </CenteredGrid>
                ) : (
                  ""
                )}

                {selectOptions.manufacturer &&
                selectOptions.model &&
                selectOptions.year &&
                selectOptions.series &&
                selectOptions.cc &&
                selectOptions.fuelType ? (
                  <CenteredGrid item xs={3}>
                    <select
                      className="select-sectio"
                      onChange={(e) =>
                        handleSection(e.target.value, "bodyType", 0)
                      }
                    >
                      <option value={null}>Body Type</option>
                      {fuelType && fuelType?.length ? (
                        <>
                          {fuelType.map((e, i) => (
                            <option key={i} title={e?.value} value={e?.value}>
                              {e.value}
                            </option>
                          ))}
                        </>
                      ) : (
                        ""
                      )}{" "}
                    </select>
                  </CenteredGrid>
                ) : (
                  ""
                )}
              </Grid>
              <div className="result-button">
                <ColorButtonYellow
                  onClick={globalSearch}
                  className="NBM-ColorButtonText"
                  startIcon={<DirectionsCarIcon />}
                  disabled={isLoading}
                >
                  {isLoading ? "Loading...." : "Search"}
                </ColorButtonYellow>
                <div className="header-section">
                  <h5>{`Vehicles Found : ${countObj.vehicleCount}`}</h5>
                </div>
                <div className="header-section">
                  <h5>{`Parts Found : ${countObj.partCount}`}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="HPC-D-Text-Main">
        {/* <Grid
          justifyContent={"center"}
          container
          mb={5}
          sx={{
            boxShadow:
              "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,rgba(228, 228, 15, 0.15) 0px 0px 0px 1px",
            padding: "3px",
            background: "#fff",
            borderRadius: "3px",
          }}
        >
          {items.map((_, index) => (
            <Grid
              key={index}
              item
              sx={{
                // margin: "0.5px",
                display: "flex",
                flexDirection: "column",
                padding: "8px",
                color: "#737373",
                border: "1px solid #fafafa",
                background: "#fff",
              }}
              alignItems={"center"}
              xs={3}
              sm={2}
              lg={1.5}
            >
              <img
                src={brand}
                alt={"img"}
                style={{
                  height: "80px",
                  width: "80px",
                }}
              />
              <div>sometext</div>
            </Grid>
          ))}
        </Grid> */}
        <h1
          className={
            isMediumScreen
              ? "HomePage-Content-Desktop-Title-Text"
              : "HomePage-Content-mobile-Title-Text"
          }
        >
          International Deliveries Via DHL
        </h1>
        <Divider orientation="horizontal" />
        <Grid
          justifyContent={"center"}
          container
          spacing={2}
          columns={{ xs: 2, sm: 8, md: 16 }}
          mt={5}
          mb={5}
        >
          <Grid
            item
            xs={2}
            sm={4}
            md={4}
            display={"flex"}
            justifyContent={"center"}
          >
            <Stack direction={direction} spacing={2}>
              <div>
                <img src={freeShipping} style={{ objectFit: "scale-down" }} />
              </div>
              <Stack direction={"column"}>
                <div>Free Shipping</div>
                <div>For orders from $50</div>
              </Stack>
            </Stack>
          </Grid>
          <Grid
            item
            xs={2}
            sm={4}
            md={4}
            display={"flex"}
            justifyContent={"center"}
          >
            <Stack direction={direction} spacing={2}>
              <div>
                <img src={hour24} style={{ objectFit: "scale-down" }} />
              </div>
              <Stack direction={"column"}>
                <div>Support 24/7</div>
                <div>Call us anytime</div>
              </Stack>
            </Stack>
          </Grid>
          <Grid
            item
            xs={2}
            sm={4}
            md={4}
            display={"flex"}
            justifyContent={"center"}
          >
            <Stack direction={direction} spacing={2}>
              <div>
                <img
                  src={paymentSecurity}
                  style={{ objectFit: "scale-down" }}
                />
              </div>
              <Stack direction={"column"}>
                <div>100% Safety</div>
                <div>Only secure payments</div>
              </Stack>
            </Stack>
          </Grid>
          <Grid
            item
            xs={2}
            sm={4}
            md={4}
            display={"flex"}
            justifyContent={"center"}
          >
            <Stack direction={direction} spacing={2}>
              <div>
                <img src={hotOffer} style={{ objectFit: "scale-down" }} />
              </div>
              <Stack direction={"column"}>
                <div>Hot Offers</div>
                <div>Discounts up to 90%</div>
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </div>
    </Box>
  );
}
